import React from 'react';
import { Form } from 'react-bootstrap-5';

import { formatPhoneNumber } from 'helpers/formatters/phone_number_formats';


type Props = {
  initialValue?: string;
  inputName: string;
}

export default function PhoneNumberInput({ initialValue, inputName }: Props) {
  const [val, setVal] = React.useState(initialValue || '');

  return (
    <Form.Group className="mb-3">
      <Form.Label>
        <strong>Phone Number *</strong>
      </Form.Label>
      <Form.Control
        id="phone-number-input"
        name={inputName}
        placeholder="(000) 000-0000"
        required
        value={formatPhoneNumber(val)}
        onChange={e => setVal(formatPhoneNumber(e.target.value))}
      />
    </Form.Group>
  );
}
